import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './phonenumber.module.css';
import axios from '../../axiosdata';
import Button from '../../UI/Buttons/Button';

class StreamUrlEditor extends Component {

    state = {
        id: this.props.information && this.props.information[0] ? this.props.information[0].id : null,
        streamUrl: this.props.information && this.props.information[0] ? this.props.information[0].streamUrl || '' : '',
        saveError: null
    }

    saveStreamUrl = () => {
        const data = { streamUrl: this.state.streamUrl };
        axios.patch(`/information/${this.state.id}.json`, data)
            .then(() => this.props.onSuccess())
            .catch(() => this.setState({ saveError: 'Tallennus epäonnistui. Yritä uudelleen.' }));
    }

    handleChange = (event) => {
        this.setState({ streamUrl: event.target.value });
    }

    render() {
        return (
            <div className={classes.infoContainer}>
                <h3>Stream URL</h3>
                <input type="text" value={this.state.streamUrl} onChange={this.handleChange} placeholder="https://..."/>
                {this.state.saveError ? <div style={{color: 'red', marginBottom: '8px'}}>{this.state.saveError}</div> : null}
                <Button click={this.saveStreamUrl}>Tallenna</Button>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    information: state.information.data
});

export default connect(mapStateToProps)(StreamUrlEditor);
